var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-preview"},[(_vm.isLoadingFile)?_c('Spinner'):_c('img',{staticClass:"image-preview__image",attrs:{"src":_vm.fileURL,"alt":_vm.fileName}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }